import React from 'react';
import classnames from 'classnames';
import { IconButton } from '../../../../core/IconButton';
import styles from './FieldIcon.module.scss';
export var FieldIcon = function (_a) {
    var className = _a.className, icon = _a.icon, label = _a.label, onClick = _a.onClick, _b = _a.position, position = _b === void 0 ? 'trailing' : _b;
    if (!icon)
        return null;
    return onClick ? (React.createElement(IconButton, { "aria-label": label, className: classnames(styles["".concat(position, "-button")], className), onClick: onClick },
        icon,
        React.createElement("span", { className: styles.srOnly }, label))) : (React.createElement("span", { className: classnames(styles[position], className) }, icon));
};
//# sourceMappingURL=FieldIcon.js.map